import { BC } from 'src/store/ActionTypes';

export const setDatasetId = (id) => ({
  type: BC.SET_DATASET_ID,
  payload: id,
});

export const setSegmentId = (id) => ({
  type: BC.SET_SEGMENT_ID,
  payload: id,
});

export const setDatasetName = (name) => ({
  type: BC.SET_DATASET_NAME,
  payload: name,
});

export const setSegmentName = (name) => ({
  type: BC.SET_SEGMENT_NAME,
  payload: name,
});

export const setSegmentNames = (names) => ({
  type: BC.SET_SEGMENT_NAMES,
  payload: names,
});

export const setModelName = (name) => ({
  type: BC.SET_MODEL_NAME,
  payload: name,
});

export const setModelNames = (names) => ({
  type: BC.SET_MODEL_NAMES,
  payload: names,
});

export const setUserEmail = (email) => ({
  type: BC.SET_USER_EMAIL,
  payload: email,
});

export const reset = () => ({
  type: BC.RESET,
});
